import { render, staticRenderFns } from "./IconPoiGym.vue?vue&type=template&id=869b3bea&"
import script from "./IconPoiGym.vue?vue&type=script&lang=js&"
export * from "./IconPoiGym.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports